import * as React from 'react';
import { useSelector } from 'react-redux';
import { VisibleViolationsWarning } from './VisibleViolationsWarning';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../selectors/analytics';
import { trackPublishWithVisibleViolationsClick } from './VisibleViolationsWarning.tracking';
import { selectIsVisibleViolationsExist } from '../../selectors/visibleViolations';

export const VisibleViolationsWarningContainer = () => {
  const isVisibleViolationsExist = useSelector(selectIsVisibleViolationsExist);
  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);

  const handleForcePublishClick = React.useCallback(() => {
    trackPublishWithVisibleViolationsClick(analyticsProduct, analyticsOfferStatus);
  }, [analyticsProduct, analyticsOfferStatus]);

  if (!isVisibleViolationsExist) {
    return null;
  }

  return <VisibleViolationsWarning handleForcePublishClick={handleForcePublishClick} />;
};
